import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";

export class BringozPackageSelectListComponent implements IController {

  optionIds: any;
  selectedType: any;
  branchIds: any;
  depotIds: any;
  ngPlaceholder: any;
  onChange: Function;

  public excludedMap: any;
  public packageTypeValues: any;
  private queryString: any;
  public options: any;
  public optionsCopy: any;
  public sitePackageItems: any;

  constructor(private splitService) {
    this.sitePackageItems = this.splitService.getSitePackageItems();
  }

  $onInit() {
    this.initOptions();
  }

  $onChanges(changes) {
    if (changes.optionIds && !changes.optionIds.isFirstChange()) {
      this.initOptions();
    }
  }

  private initOptions() {
    if (!this.optionIds) {
      this.options = angular.copy(this.sitePackageItems);
    } else {
      this.options = [];
      _.forEach(this.sitePackageItems, (siteItem) => {
        if (_.includes(this.optionIds, siteItem.id)) {
          this.options.push(siteItem);
        }
      })
    }
    this.optionsCopy = angular.copy(this.options);
  }

  submitQuery(query) {
    this.queryString = query;
    this.options = _.filter(this.optionsCopy, (siteItem) => {
      return _.lowerCase(siteItem.name).includes(_.lowerCase(query))
    })
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozPackageSelectList', {
    bindings: {
      optionIds: '<?',
      selectedType: '<',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./bringoz-package-select-list.html').default,
    controller: BringozPackageSelectListComponent
  });
